import React from "react";
import "./Navbar.css";
import logo from "../Images/brandlogo.png";

const Navbar = () => {
  return (
    <div style={{background:"#fff"}}>
      <nav id="navbar" className='arvrcontainer'>
      <a href="#">
        <img src={logo} alt="logo" className="nav-logo"/>
      </a>
      <div>
        {/* <button type="button" className="nav-button">Contact Us</button> */}
      </div>
    </nav>
    </div>
  );
};

export default Navbar;
